module.exports = "https://d3nn82uaxijpm6.cloudfront.net/packs/media/components/map/images/map-marker-range-start-77f066e6ee852585f90f17462f93642b.png";